





















































import { i18n } from '@tt4b/ttam-i18n';
import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import SwitchContainer from '@/components/common/switch-container/index.vue';
import TtamTrackingBrandSafetySelect from './select.vue';

const name = 'ttam-tracking-brand-safety';

export default defineComponent({
  name,

  components: {
    SwitchContainer,
    TtamTrackingBrandSafetySelect,
  },

  props: {
    switchValue: { type: Boolean, default: false },
    url: { type: String, default: '' },
    type: { type: Number, default: undefined },
    rules: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    titleHint: {
      type: String,
      default: i18n.t('module_track_url_brand_safety_title_hint'),
    },
    placeholder: {
      type: String,
      default: i18n.t('module_brand_safety_input_placeholder'),
    },
    switchHint: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    options: {
      type: Array as PropType<
        {
          value: string;
          label: string;
          disabled: boolean;
          hintKey?: string;
          linkKey?: string;
          linkUrl?: string;
          linkPlace?: string;
        }[]
      >,
      default: () => [],
    },
    isIASSelect: { type: Boolean, default: false },
    isOnlyShowBsIas: { type: Boolean, default: true },
    isOnlyOneBrandSafetyTrackType: { type: Boolean, default: true },
    isOptionsLoading: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { switchValue, url, type } = toRefs(props);

    const formItemRef = ref(null);

    const handleResetField = () => {
      formItemRef.value?.resetField?.();
    };

    const handleEmit = (eventName, value) => {
      handleResetField();
      emit(eventName, value);
    };

    const _switchValue = computed({
      get: () => switchValue.value,
      set: val => handleEmit('switch-change', val),
    });

    const _url = computed({
      get: () => url.value,
      set: val => handleEmit('url-change', val),
    });

    const _type = computed({
      get: () => type.value,
      set: val => handleEmit('type-change', val),
    });

    return {
      name,
      _url,
      _type,
      _switchValue,
      formItemRef,
    };
  },
});
